
export const AlignRight = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.234 18V6H17.334V18H16.234ZM9.63398 15V13.2H15.134V15H9.63398ZM6.33398 10.8V9H15.134V10.8H6.33398Z" fill={color}/>
    </svg>
  );
}